import React, { useEffect, useState } from 'react';
import {useQuery} from "react-query";
import {GetCacheKey} from "../../../services/common/utils";
import { object } from 'prop-types';
import AccordionComponent from "../../../components/common/accordion";
import Loadingcomponent from '../../loader/loadingcomponent';
import SearchErrorHandler from '../../common/search-error-handler';
import { useTranslation } from 'react-i18next';
import RoamingPackCountriesShimmer from '../../../ShimmerEffect/RoamingPackCountriesShimmer';
import RoamingCountriesList from '../../../ShimmerEffect/RoamingCountriesList';

function AllRoamingCountries({pmsitem, search, bgcolor}) {
  const [filteredData, setFilteredData] = useState();
  const { t } = useTranslation();
  const [count, setCount] = useState(null);
  const {
    data: {data}={},
    isSuccess,
    isLoading,
    isFetching
  }= useQuery([GetCacheKey('Roaming_countries_list'), pmsitem?.method, JSON.parse(pmsitem?.sourceid), {}])

  useEffect(()=>{
    if(data){
        let countriesList = {}
        countriesList[data?.response?.popularcountriesheading] =
         search?.length > 0 ?  
          data?.response?.Popularcountries?.filter(item => item?.country?.toLowerCase()?.includes(search?.toLowerCase())) :
          data?.response?.Popularcountries;

        countriesList[data?.response?.allcountriesheading] = search?.length > 0 ?  
          data?.response?.Allcountries?.filter((item)=> item?.country?.toLowerCase()?.includes(search?.toLowerCase())) :
          data?.response?.Allcountries;
         setCount(countriesList[data?.response?.popularcountriesheading]?.length + countriesList[data?.response?.allcountriesheading]?.length );
        let sorted_obj = Object.keys(countriesList)?.reduce((temp_obj, key, index)=>{
          temp_obj[key] = countriesList[key];
          return temp_obj;
        }, {});
        setFilteredData(sorted_obj);
    }
  }, [data?.response, search]);
  
  return (
    <div className='pse_sm'>
      { isLoading || isFetching ? <RoamingCountriesList/> : 
        
        count === 0 ? 
        <p style={{ textAlign: 'center' }} className='mt-4 mb-0'>
          {t("nodata")}
        </p>: filteredData &&
          Object.keys(filteredData)?.map(element =>(
            <div className="">
            {filteredData[element]?.length > 0 &&
              <h6 className="pt-4 pb-3 ">{element}</h6>
            }
              <>
                {filteredData[element]?.map(item => (
                  <AccordionComponent type={7} data={item} banners={data?.response?.banners} pmsitem={pmsitem} bgcolor={bgcolor}></AccordionComponent>
                ))}
              </>
            </div>
          ))
      }
    </div>
  )
}

export default AllRoamingCountries;
